import { render, staticRenderFns } from "./teacherStudentStno.vue?vue&type=template&id=402914b5&scoped=true"
import script from "./teacherStudentStno.vue?vue&type=script&lang=ts"
export * from "./teacherStudentStno.vue?vue&type=script&lang=ts"
import style0 from "./teacherStudentStno.vue?vue&type=style&index=0&id=402914b5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402914b5",
  null
  
)

export default component.exports